import { connect } from 'react-redux';
import { resetPassword } from 'data/login/login.actions';
import ResetPasswordContainer from './ResetPasswordContainer';

const actions = {
  resetPassword
};

function mapStateToProps(state) {
  return {
    resetPasswordLoading: state.login.resetPasswordLoading,
    resetPasswordSuccess: state.login.resetPasswordSuccess
  };
}

export default connect(mapStateToProps, actions)(ResetPasswordContainer);
